import ProfileAvatar from "PFComponents/profile_avatar/profile_avatar";
import KeyboardIcon from "PFIcons/keyboard";
import PropTypes from "prop-types";
import React from "react";

import css from "./post_button.less";

const PostButton = ({ profile, handleClick, text }) => (
  <div className={css.wrapper}>
    <ProfileAvatar size={40} profile={profile} />
    {/* eslint-disable-next-line max-len */}
    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
    <div className={css.text} onClick={handleClick}>
      {text}
    </div>
    <KeyboardIcon />
  </div>
);

PostButton.propTypes = {
  handleClick: PropTypes.func,
  text: PropTypes.string,
  profile: PropTypes.shape({
    avatar: PropTypes.shape({
      thumbnail_url: PropTypes.string
    })
  })
};

export default PostButton;
